import { render, staticRenderFns } from "./OrdersPlanningInventoryConfirmationDialog.vue?vue&type=template&id=00c284a9&"
import script from "./OrdersPlanningInventoryConfirmationDialog.vue?vue&type=script&lang=ts&"
export * from "./OrdersPlanningInventoryConfirmationDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports